// extracted by mini-css-extract-plugin
export default {"banner":"Login_banner__3wz7r","content":"Login_content__wXLNJ","title":"Login_title__KOkvv","graphic":"Login_graphic__eF635"};